export default __webpack_public_path__ + "react-assets/empty-state.svg";